import { Alert, Box, Slide } from '@mui/material'
import { useEffect, useState } from 'react'
import { useAnimatedAlert } from '~components/molecules/animated-alert/animated-alert-provider'
import { COLORS } from '~theme/colors'

export const AnimatedAlert = () => {
  const { isVisible } = useAnimatedAlert()

  return isVisible ? <AnimatedAlertInner /> : null
}

const AnimatedAlertInner = () => {
  const {
    variant: newVariant,
    text: newText,
    setIsVisible,
    delay,
  } = useAnimatedAlert()

  const [slideIn, setSlideIn] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => setSlideIn(false), delay)
    return () => clearTimeout(timer)
  }, [delay])

  return (
    <Box
      sx={{
        position: 'fixed',
        width: '100%',
        height: 0,
        bottom: 0,
        left: 0,
        zIndex: 999999,
      }}
    >
      <Slide
        in={slideIn}
        direction="up"
        timeout={200}
        onExited={() => setIsVisible(false)}
      >
        <Box sx={{ position: 'absolute', bottom: '1rem', right: '1rem' }}>
          <Alert
            severity={newVariant}
            sx={{
              alignItems: 'center',
              ...(newVariant === 'warning' && {
                background: COLORS.orange.tint5,
                svg: { color: COLORS.orange.dark },
              }),
            }}
          >
            {newText}
          </Alert>
        </Box>
      </Slide>
    </Box>
  )
}
